import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

interface BookingConflict {
  chargeId: number;
  memberName: string;
  bookingStartTime: string | Date;
  bookingEndTime: string | Date;
}

interface Props {
  conflicts: BookingConflict[];
}

export function BookingConflictAlert({ conflicts }: Props) {
  if (conflicts.length === 0) return null;
  const c = conflicts[0]!;
  const start = new Date(c.bookingStartTime);
  const end = new Date(c.bookingEndTime);
  const dateLabel = start.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  const timeLabel = `${start.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })} – ${end.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}`;
  return (
    <Alert className="border-amber-300 bg-amber-50 text-amber-800">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertTitle>Scheduling conflict detected</AlertTitle>
      <AlertDescription>
        Conflicts with: {c.memberName}. {timeLabel} on {dateLabel}.
        You may still proceed. Double-bookings are operator-approved.
      </AlertDescription>
    </Alert>
  );
}
